import { render, staticRenderFns } from "./jsonEditor.vue?vue&type=template&id=bd8cebd8&scoped=true&"
import script from "./jsonEditor.vue?vue&type=script&lang=js&"
export * from "./jsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./jsonEditor.vue?vue&type=style&index=0&id=bd8cebd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8cebd8",
  null
  
)

export default component.exports